import { configureStore } from "@reduxjs/toolkit";
import { playbookApi } from "../features/references/api/playbookApi";
import { inferenceApi } from "../features/draft/api/inferenceApi";
import { settingsApi } from "../features/draft/api/settingsApi";
import { checkoutApi } from "../features/checkout/api/checkoutApi";
import { filingApi } from "../features/filing/api/filingApi";

export const store = configureStore({
  reducer: {
    [playbookApi.reducerPath]: playbookApi.reducer,
    [inferenceApi.reducerPath]: inferenceApi.reducer,
    [settingsApi.reducerPath]: settingsApi.reducer,
    [checkoutApi.reducerPath]: checkoutApi.reducer,
    [filingApi.reducerPath]: filingApi.reducer,
  },
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware().concat(
      playbookApi.middleware,
      inferenceApi.middleware,
      settingsApi.middleware,
      checkoutApi.middleware,
      filingApi.middleware
    ),
});

export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;
